import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import FormInputDropdown from "../FormInputDropdown/FormInputDropdown";
import FormInputTextField from 'components/FormInputTextField/FormInputTextField.vue'
import nonEmptyStringValidator from "foundation/js/inputValidators/nonEmptyStringValidator";

export default {
    name: "LotteryForm",
    props: {
        lotteryRounds : {
            type: Object,
            required: true
        }
    },
    components: {
        FormInputDropdown,
        FormInputTextField
    },
    setup(props){
        const store = useStore()
        const getLabel = (labelKey, params) =>
            store.getters['labels/getLabel']({
                labelCollection: 'lotteryForm',
                labelKey,
                params
            })
            
        const lotteryDropdown = ref('')
        const controlNumber = ref('')
        const displayFormValidationError = ref(false)
        const displayLotteryTicketError = ref(false)

        const showSpinner = computed(() => store.state.lottery.submitting)
        const lotteryTicket = computed(() => store.state.lottery.lottery_ticket)
        const showResultPage = ref(false)
        const controlNumberValidationErrorLabel = computed(() => 
            getLabel(displayLotteryTicketError ? 'validationMessage' : getLabel('controlNumberError')))
        const lotteryDropdownOptions = computed(() => props.lotteryRounds.map(r => {
            return {
                name: r.roundName,
                value: r.roundId
            }
        }))


        const validateFields = () => {
            return nonEmptyStringValidator(lotteryDropdown.value)
                && nonEmptyStringValidator(controlNumber.value)
        }

        const onSubmit = () => {
            displayLotteryTicketError.value = false

            if(!validateFields()){
                displayFormValidationError.value = true

                return
            }

            store.dispatch('lottery/getLotteryTicketResult', {
                roundNumber: lotteryDropdown.value,
                lotteryTicketId: controlNumber.value
            })
            .then((resp) => {
                showResultPage.value = true
            })
            .catch((_) =>{
                displayLotteryTicketError.value = true
            })
        }

        const clear = () => {
            displayFormValidationError.value = false
            controlNumber.value = ''
            lotteryDropdown.value = ''
            showResultPage.value = false

            store.commit('lottery/SET_LOTTERY_TICKET', undefined)
        }

        return {
            lotteryDropdown,
            controlNumber,
            displayFormValidationError,
            nonEmptyStringValidator,
            showSpinner,
            lotteryTicket,
            showResultPage,
            displayLotteryTicketError,
            controlNumberValidationErrorLabel,
            lotteryDropdownOptions,
            getLabel,
            onSubmit,
            clear
        }
    }
}